import { tFunctionType } from 'app/services/localization';
import * as iots from 'io-ts';

export const ErrorWithMessage = iots.type({
  message: iots.string,
});

/**
 * Convenience function that takes a list of error matchers and
 * returns a function that returns the result of the first mached
 * error.
 *
 * Each matcher returns a string if it matched the error or `null`
 * if it didn't.
 */
export const errorMessageFinder =
  (formatters: Array<((t: tFunctionType, error: unknown) => null | string)>) =>
    (t: tFunctionType, error: unknown): string => {
      for (const formatter of formatters) {
        const result = formatter(t, error);
        if (result !== null) {
          return result;
        }
      }

      if (ErrorWithMessage.is(error)) {
        return error.message;
      } else {
        return JSON.stringify(error);
      }
    };

/**
 * Returns error info for useful properties that are not normally enumerable
 */
export const dumpErrorInfo = (error: Error) => {
  try {
    const { name, message, stack, ...rest } = error;
    return {
      name,
      message,
      stack,
      ...rest,
    };
  } catch (_) {
    return error;
  }
};
